import store from '../store'
import { HTTP_HYPER_ESPACE_BACKEND } from "@/services/http-common";

/**
 * retourne les équipements personalisés de l'annonceur
 * @returns {Promise<*[]>}
 */
export async function getAdvertiserEquipments () {
  const url = '/equipements?advertiser=' + store.getters.getSitimmoUser.id
  return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
    let equipments = []
    if (response.data && response.data[0] && response.data[0].equipements) {
      equipments = response.data[0]
    }
    return equipments
  })
}

/**
 * mise à jour des équipements de l'annonceur
 * @param idEquipements
 * @param equipements
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function postAdvertiserEquipments (idEquipements, equipements) {
  let url = '/equipements'
  const data = {
    advertiser: store.getters.getSitimmoUser.id.toString(),
    equipements: equipements
  }
  if (idEquipements) {
    url = url + '/' + idEquipements
    return HTTP_HYPER_ESPACE_BACKEND.put(url, data)
  } else {
    return HTTP_HYPER_ESPACE_BACKEND.post(url, data)
  }
}

/**
 * @param labels
 * @returns {[{code: string, value: *}]}
 */
export function getDefaultEquipments (labels) {
  return [
    { code: 'abs', value: labels.abs },
    { code: 'allumage_automatique_des_feux', value: labels.allumage_automatique_des_feux },
    { code: 'detecteur_de_pluie', value: labels.detecteur_de_pluie },
    { code: 'attache_remorque', value: labels.attache_remorque },
    { code: 'direction_assistee', value: labels.direction_assistee },
    { code: 'fermeture_centralisee', value: labels.fermeture_centralisee },
    { code: 'jantes_aluminium', value: labels.jantes_aluminium },
    { code: 'phares_antibrouillard', value: labels.phares_antibrouillard },
    { code: 'projecteurs_xenon', value: labels.projecteurs_xenon },
    { code: 'radar_aide_stationnement', value: labels.radar_aide_stationnement },
    { code: 'vitres_avant_electriques', value: labels.vitres_avant_electriques },
    { code: 'vitres_arrieres_electriques', value: labels.vitres_arrieres_electriques }
  ]
}

/**
 * @param labels
 * @returns {[{code: string, value: *}]}
 */
export function getComfortEquipments (labels) {
  return [
    { code: 'accoudoir_central', value: labels.accoudoir_central },
    { code: 'affichage_tete_haute', value: labels.affichage_tete_haute },
    { code: 'apple_carplay', value: labels.apple_carplay },
    { code: 'android_auto', value: labels.android_auto },
    { code: 'auto_radio_commande_au_volant', value: labels.auto_radio_commande_au_volant },
    { code: 'auvent', value: labels.auvent },
    { code: 'banquette_1_3_2_3', value: labels.banquette_1_3_2_3 },
    { code: 'barres_de_toit', value: labels.barres_de_toit },
    { code: 'bulle_electrique', value: labels.bulle_electrique },
    { code: 'bulle_haute', value: labels.bulle_haute },
    { code: 'bulle_reglable', value: labels.bulle_reglable },
    { code: 'capote_electrique', value: labels.capote_electrique },
    { code: 'carte_main_libre', value: labels.carte_main_libre },
    { code: 'chauffage_stationnaire', value: labels.chauffage_stationnaire },
    { code: 'demarreur_electrique', value: labels.demarreur_electrique },
    { code: 'dosseret', value: labels.dosseret },
    { code: 'filet_anti_remous', value: labels.filet_anti_remous },
    { code: 'gps', value: labels.gps },
    { code: 'gps_16_9eme', value: labels.gps_16_9eme },
    { code: 'gps_couleur', value: labels.gps_couleur },
    { code: 'gps_tactile', value: labels.gps_tactile },
    { code: 'gps_tv', value: labels.gps_tv },
    { code: 'hard_top', value: labels.hard_top },
    { code: 'housse_de_protection', value: labels.housse_de_protection },
    { code: 'interieur_bois', value: labels.interieur_bois },
    { code: 'jupe', value: labels.jupe },
    { code: 'lecteur_dvd', value: labels.lecteur_dvd },
    { code: 'manchons', value: labels.manchons },
    { code: 'marchepieds', value: labels.marchepieds },
    { code: 'ordinateur_de_bord', value: labels.ordinateur_de_bord },
    { code: 'poignees_chauffantes', value: labels.poignees_chauffantes },
    { code: 'porte_bagage', value: labels.porte_bagage },
    { code: 'porte_laterale', value: labels.porte_laterale },
    { code: 'radio', value: labels.radio },
    { code: 'repose_pieds', value: labels.repose_pieds },
    { code: 'retroviseurs_degivrants', value: labels.retroviseurs_degivrants },
    { code: 'retroviseurs_electriques', value: labels.retroviseurs_electriques },
    { code: 'retroviseurs_rabattables', value: labels.retroviseurs_rabattables },
    { code: 'rideaux_pare_soleil', value: labels.rideaux_pare_soleil },
    { code: 'sacoches', value: labels.sacoches },
    { code: 'selle_confort', value: labels.selle_confort },
    { code: 'selle_reglable', value: labels.selle_reglable },
    { code: 'sieges_chauffants', value: labels.sieges_chauffants },
    { code: 'sieges_confort', value: labels.sieges_confort },
    { code: 'sieges_electriques', value: labels.sieges_electriques },
    { code: 'sieges_enfants_integres', value: labels.sieges_enfants_integres },
    { code: 'sieges_pivotants', value: labels.sieges_pivotants },
    { code: 'sieges_sport', value: labels.sieges_sport },
    { code: 'sissy_bar', value: labels.sissy_bar },
    { code: 'systeme_d_aide_au_stationnement', value: labels.systeme_d_aide_au_stationnement },
    { code: 'telephone_fixe', value: labels.telephone_fixe },
    { code: 'predisposition_telephone', value: labels.predisposition_telephone },
    { code: 'toit_ouvrant', value: labels.toit_ouvrant },
    { code: 'toit_ouvrant_electrique', value: labels.toit_ouvrant_electrique },
    { code: 'toit_ouvrant_electrique_en_verre', value: labels.toit_ouvrant_electrique_en_verre },
    { code: 'toit_ouvrant_panoramique', value: labels.toit_ouvrant_panoramique },
    { code: 'toit_panoramique', value: labels.toit_panoramique },
    { code: 'top_case', value: labels.top_case },
    { code: 'top_case_avant', value: labels.top_case_avant },
    { code: 'valises', value: labels.valises },
    { code: 'vitres_electriques', value: labels.vitres_electriques },
    { code: 'vitres_surteintees', value: labels.vitres_surteintees },
    { code: 'volant_bois', value: labels.volant_bois },
    { code: 'volant_multifonctions', value: labels.volant_multifonctions },
    { code: 'volant_reglable', value: labels.volant_reglable },
    { code: 'volant_sport', value: labels.volant_sport },
    { code: 'regulateur_de_vitesse', value: labels.regulateur_de_vitesse },
    { code: 'sieges_electriques_a_memoire', value: labels.sieges_electriques_a_memoire },
    { code: 'commandes_reculees', value: labels.commandes_reculees },
    { code: 'guidon_reglable', value: labels.guidon_reglable },
    { code: 'kit_passager', value: labels.kit_passager },
    { code: 'pare_mains', value: labels.pare_mains },
    { code: 'repose_pieds_reglable', value: labels.repose_pieds_reglable },
    { code: 'selle_basse', value: labels.selle_basse },
    { code: 'selle_haute', value: labels.selle_haute },
    { code: 'selle_chauffante', value: labels.selle_chauffante },
    { code: 'selle_personnalisee', value: labels.selle_personnalisee },
    { code: 'bluetooth', value: labels.bluetooth },
    { code: 'tete_de_fourche', value: labels.tete_de_fourche },
    { code: 'sieges_reglables_en_hauteur', value: labels.sieges_reglables_en_hauteur },
    { code: 'accumulateur_de_chaleur_latente', value: labels.accumulateur_de_chaleur_latente },
    { code: 'aide_au_demarrage_en_pente', value: labels.aide_au_demarrage_en_pente },
    { code: 'accoudoir_central_arriere', value: labels.accoudoir_central_arriere },
    { code: 'appuie_reins_conduteur', value: labels.appuie_reins_conduteur },
    { code: 'appuie_reins_conduteur_electrique', value: labels.appuie_reins_conduteur_electrique },
    { code: 'appuie_reins_passager', value: labels.appuie_reins_passager },
    { code: 'appuie_reins_passager_electrique', value: labels.appuie_reins_passager_electrique },
    { code: 'cle_mains_libres', value: labels.cle_mains_libres },
    { code: 'suspension_pilotee', value: labels.suspension_pilotee },
    { code: 'proteges_mains', value: labels.proteges_mains },
    { code: 'miroir_courtoisie_conducteur', value: labels.miroir_courtoisie_conducteur },
    { code: 'porte_gobelet_avant', value: labels.porte_gobelet_avant },
    { code: 'porte_gobelet_arriere', value: labels.porte_gobelet_arriere },
    { code: 'lecteur_dvd_avant', value: labels.lecteur_dvd_avant },
    { code: 'lecteur_dvd_arriere', value: labels.lecteur_dvd_arriere },
    { code: 'siege_cond_reglable_en_hauteur', value: labels.siege_cond_reglable_en_hauteur },
    { code: 'siege_pass_reglable_en_hauteur', value: labels.siege_pass_reglable_en_hauteur },
    { code: 'miroir_courtoisie_passager', value: labels.miroir_courtoisie_passager },
    { code: 'ecran_multifonction', value: labels.ecran_multifonction },
    { code: 'prise_audio_usb', value: labels.prise_audio_usb },
    { code: 'telephone_commande_au_volant', value: labels.telephone_commande_au_volant },
    { code: 'siege_chauffant_cond', value: labels.siege_chauffant_cond },
    { code: 'siege_chauffant_pass', value: labels.siege_chauffant_pass },
    { code: 'auto_radio', value: labels.auto_radio },
    { code: 'auto_radio_rds', value: labels.auto_radio_rds },
    { code: 'deflecteurs', value: labels.deflecteurs },
    { code: 'bulle_racing', value: labels.bulle_racing },
    { code: 'systeme_de_navigation', value: labels.systeme_de_navigation },
    { code: 'climatisation_automatique', value: labels.climatisation_automatique },
    { code: 'sieges_ventiles', value: labels.sieges_ventiles },
    { code: 'soudsystem', value: labels.soudsystem },
    { code: 'coupe_vent_pour_cabriolet', value: labels.coupe_vent_pour_cabriolet },
    { code: 'capteurs_d_aide_au_stationnement_avant', value: labels.capteurs_d_aide_au_stationnement_avant },
    { code: 'capteurs_d_aide_au_stationnement_arriere', value: labels.capteurs_d_aide_au_stationnement_arriere },
    { code: 'volant_chauffant', value: labels.volant_chauffant },
    { code: 'radio_numerique', value: labels.radio_numerique },
    { code: 'siege_a_reglage_lombaire', value: labels.siege_a_reglage_lombaire },
    { code: 'sieges_massants', value: labels.sieges_massants },
    { code: 'ecran_tactile', value: labels.ecran_tactile },
    { code: 'fonction_tv', value: labels.fonction_tv },
    { code: 'usb', value: labels.usb },
    { code: 'cd', value: labels.cd },
    { code: 'mp3', value: labels.mp3 },
    { code: 'hayon_arriere_electrique', value: labels.hayon_arriere_electrique },
    { code: 'vide_poche_porte_avant', value: labels.vide_poche_porte_avant },
    { code: 'lampe_coffre', value: labels.lampe_coffre },
    { code: 'filtre_a_pollen', value: labels.filtre_a_pollen },
    { code: 'prise_audio_aux', value: labels.prise_audio_aux },
    { code: 'auto_radio_cd_avec_chargeur', value: labels.auto_radio_cd_avec_chargeur },
    { code: 'auto_radio_k7', value: labels.auto_radio_k7 },
    { code: 'climatisation_multi_zone', value: labels.climatisation_multi_zone },
    { code: 'climatisation_manuelle', value: labels.climatisation_manuelle },
    { code: 'climatisation', value: labels.climatisation },
    { code: 'direction_assistee_servotronic', value: labels.direction_assistee_servotronic },
    { code: 'dosseret_passager', value: labels.dosseret_passager },
    { code: 'dosseret_pilote', value: labels.dosseret_pilote },
    { code: 'dosseret_selle', value: labels.dosseret_selle },
    { code: 'dosseret_top_case', value: labels.dosseret_top_case },
    { code: 'volant_reglable_hauteur', value: labels.volant_reglable_hauteur },
    { code: 'volant_reglable_profondeur', value: labels.volant_reglable_profondeur },
    { code: 'siege_cond_reglable_lombaire', value: labels.siege_cond_reglable_lombaire },
    { code: 'siege_cond_reglage_lombaire_electrique', value: labels.siege_cond_reglage_lombaire_electrique },
    { code: 'siege_cond_reglage_lombaire_manuel', value: labels.siege_cond_reglage_lombaire_manuel },
    { code: 'siege_pass_reglable_lombaire', value: labels.siege_pass_reglable_lombaire },
    { code: 'siege_pass_reglage_lombaire_electrique', value: labels.siege_pass_reglage_lombaire_electrique },
    { code: 'siege_pass_reglage_lombaire_manuel', value: labels.siege_pass_reglage_lombaire_manuel }
  ]
}

/**
 * @param labels
 * @returns {[{code: string, value: *}]}
 */
export function getSecurityEquipments (labels) {
  return [
    { code: 'airbag', value: labels.airbag },
    { code: 'airbags_frontaux', value: labels.airbags_frontaux },
    { code: 'airbags_lateraux', value: labels.airbags_lateraux },
    { code: 'alarme', value: labels.alarme },
    { code: 'afil', value: labels.afil },
    { code: 'anti_demarrage', value: labels.anti_demarrage },
    { code: 'anti_patinage', value: labels.anti_patinage },
    { code: 'anti_wheeling', value: labels.anti_wheeling },
    { code: 'casque', value: labels.casque },
    { code: 'capteur_inclinaison', value: labels.capteur_inclinaison },
    { code: 'clignotants', value: labels.clignotants },
    { code: 'controle_pression_des_pneus', value: labels.controle_pression_des_pneus },
    { code: 'coupe_circuit', value: labels.coupe_circuit },
    { code: 'esp', value: labels.esp },
    { code: 'frein_parking_automatique', value: labels.frein_parking_automatique },
    { code: 'freinage_couple', value: labels.freinage_couple },
    { code: 'freins_arriere_disque', value: labels.freins_arriere_disque },
    { code: 'freins_avant_disque', value: labels.freins_avant_disque },
    { code: 'homologue_route', value: labels.homologue_route },
    { code: 'phares', value: labels.phares },
    { code: 'pneus_neige', value: labels.pneus_neige },
    { code: 'protege_carter', value: labels.protege_carter },
    { code: 'protege_cylindres', value: labels.protege_cylindres },
    { code: 'stabilisateurs', value: labels.stabilisateurs },
    { code: 'suspension_pneumatique', value: labels.suspension_pneumatique },
    { code: 'suspension_sport', value: labels.suspension_sport },
    { code: 'systeme_d_identification_du_conducteur', value: labels.systeme_d_identification_du_conducteur },
    { code: 'tatouage_antivol', value: labels.tatouage_antivol },
    { code: 'warning', value: labels.warning },
    { code: 'radar_obstacle_avant', value: labels.radar_obstacle_avant },
    { code: 'radar_obstacle_arriere', value: labels.radar_obstacle_arriere },
    { code: 'feux_detresse', value: labels.feux_detresse },
    { code: 'camera_recul', value: labels.camera_recul },
    { code: 'asr', value: labels.asr },
    { code: 'protections_laterales', value: labels.protections_laterales },
    { code: 'afu', value: labels.afu },
    { code: 'repartiteur_electronique_de_freinage', value: labels.repartiteur_electronique_de_freinage },
    { code: 'fixations_isofix', value: labels.fixations_isofix },
    { code: 'airbags_rideaux', value: labels.airbags_rideaux },
    { code: 'airbag_anti_sous_marinage', value: labels.airbag_anti_sous_marinage },
    { code: 'verrouillage_automatique_des_portes_en_roulant', value: labels.verrouillage_automatique_des_portes_en_roulant },
    { code: 'blocage_electronique_du_differentiel', value: labels.blocage_electronique_du_differentiel },
    { code: 'retroviseur_interieur_electrochrome', value: labels.retroviseur_interieur_electrochrome },
    { code: 'kit_depannage_pneumatique', value: labels.kit_depannage_pneumatique },
    { code: 'roue_secours', value: labels.roue_secours },
    { code: 'airbag_conducteur', value: labels.airbag_conducteur },
    { code: 'phares_directionnels', value: labels.phares_directionnels },
    { code: 'feux_de_circulation_diurne', value: labels.feux_de_circulation_diurne },
    { code: 'antivol_u', value: labels.antivol_u },
    { code: 'antivol_bloc_disque', value: labels.antivol_bloc_disque },
    { code: 'antivol_chaine', value: labels.antivol_chaine },
    { code: 'bumper_avant', value: labels.bumper_avant },
    { code: 'bumper_arriere', value: labels.bumper_arriere },
    { code: 'airbag_genoux_conducteur', value: labels.airbag_genoux_conducteur },
    { code: 'airbags_rideaux_avant', value: labels.airbags_rideaux_avant },
    { code: 'airbags_rideaux_arriere', value: labels.airbags_rideaux_arriere },
    { code: 'airbag_genoux_passager', value: labels.airbag_genoux_passager },
    { code: 'airbags_lateraux_avants', value: labels.airbags_lateraux_avants },
    { code: 'airbags_lateraux_arrieres', value: labels.airbags_lateraux_arrieres },
    { code: 'airbags_frontaux_avants', value: labels.airbags_frontaux_avants },
    { code: 'airbags_frontaux_arrieres', value: labels.airbags_frontaux_arrieres },
    { code: 'controle_descente', value: labels.controle_descente },
    { code: 'airbag_passager', value: labels.airbag_passager },
    { code: 'airbag_passager_desactivable', value: labels.airbag_passager_desactivable },
    { code: 'suspension_magnetique', value: labels.suspension_magnetique },
    { code: 'equipement_handicape', value: labels.equipement_handicape },
    { code: 'airbag_arriere', value: labels.airbag_arriere },
    { code: 'airbag_avant', value: labels.airbag_avant },
    { code: 'avertisseur_d_angle_mort', value: labels.avertisseur_d_angle_mort },
    { code: 'phare_de_jour', value: labels.phare_de_jour },
    { code: 'detecteur_de_lumiere', value: labels.detecteur_de_lumiere },
    { code: 'regulateur_de_distance', value: labels.regulateur_de_distance },
    { code: 'led_phare_de_jour', value: labels.led_phare_de_jour },
    { code: 'systeme_de_detection_de_la_somnolence', value: labels.systeme_de_detection_de_la_somnolence },
    { code: 'assistant_de_vision_nocturne', value: labels.assistant_de_vision_nocturne },
    { code: 'systeme_d_appel_d_urgence', value: labels.systeme_d_appel_d_urgence },
    { code: 'detection_des_panneaux_routiers', value: labels.detection_des_panneaux_routiers },
    { code: 'troisieme_ceinture', value: labels.troisieme_ceinture },
    { code: 'phares_halogenes', value: labels.phares_halogenes }
  ]
}

/**
 * @param labels
 * @returns {[{code: string, value: *}]}
 */
export function getOtherEquipments (labels) {
  return [
    { code: 'acces_confort', value: labels.acces_confort },
    { code: 'assistant_changement_voie', value: labels.assistant_changement_voie },
    { code: 'attelage', value: labels.attelage },
    { code: 'carenage', value: labels.carenage },
    { code: 'chargeur_smartphone_sans_fil', value: labels.chargeur_smartphone_sans_fil },
    { code: 'chassis_sport', value: labels.chassis_sport },
    { code: 'compteur_vitesse_numerique', value: labels.compteur_vitesse_numerique },
    { code: 'clignotant_goutte_d_eau', value: labels.clignotant_goutte_d_eau },
    { code: 'demarreur_manuel', value: labels.demarreur_manuel },
    { code: 'durits_aviation', value: labels.durits_aviation },
    { code: 'ecran_passager', value: labels.ecran_passager },
    { code: 'esp', value: labels.esp },
    { code: 'galerie', value: labels.galerie },
    { code: 'garde_boue_arriere', value: labels.garde_boue_arriere },
    { code: 'indicateur_rapport_engage', value: labels.indicateur_rapport_engage },
    { code: 'mode_conduite_pluie', value: labels.mode_conduite_pluie },
    { code: 'mode_conduite_piste', value: labels.mode_conduite_piste },
    { code: 'non_fumeur', value: labels.non_fumeur },
    { code: 'pack_chrome', value: labels.pack_chrome },
    { code: 'pack_confort', value: labels.pack_confort },
    { code: 'pack_cuir', value: labels.pack_cuir },
    { code: 'pack_electrique', value: labels.pack_electrique },
    { code: 'pack_hifi', value: labels.pack_hifi },
    { code: 'pack_hiver', value: labels.pack_hiver },
    { code: 'pack_loisir', value: labels.pack_loisir },
    { code: 'pack_luxe', value: labels.pack_luxe },
    { code: 'pack_sport', value: labels.pack_sport },
    { code: 'pack_sport_chrono', value: labels.pack_sport_chrono },
    { code: 'pack_visibilite', value: labels.pack_visibilite },
    { code: 'pare_carters', value: labels.pare_carters },
    { code: 'pare_cylindres', value: labels.pare_cylindres },
    { code: 'pare_brise_chauffant', value: labels.pare_brise_chauffant },
    { code: 'pare_buffle', value: labels.pare_buffle },
    { code: 'passage_de_roue', value: labels.passage_de_roue },
    { code: 'peinture_integrale', value: labels.peinture_integrale },
    { code: 'peinture_personnalisee', value: labels.peinture_personnalisee },
    { code: 'projecteurs_xenon', value: labels.projecteurs_xenon },
    { code: 'projecteurs_bi_xenon', value: labels.projecteurs_bi_xenon },
    { code: 'roues_arriere_directrices', value: labels.roues_arriere_directrices },
    { code: 'sabot', value: labels.sabot },
    { code: 'sac_reservoir', value: labels.sac_reservoir },
    { code: 'shifter_up_down', value: labels.shifter_up_down },
    { code: 'suspension_reglable', value: labels.suspension_reglable },
    { code: 'tuning', value: labels.tuning },
    { code: 'tapis_reservoir', value: labels.tapis_reservoir },
    { code: 'bas_de_carenage', value: labels.bas_de_carenage },
    { code: 'bequet_central', value: labels.bequet_central },
    { code: 'boite_de_vitesse', value: labels.boite_de_vitesse },
    { code: 'support_de_u', value: labels.support_de_u },
    { code: 'clignotants_blancs', value: labels.clignotants_blancs },
    { code: 'pare_brise', value: labels.pare_brise },
    { code: 'echappement_4_1', value: labels.echappement_4_1 },
    { code: 'kit_34ch', value: labels.kit_34ch },
    { code: 'support_top_case', value: labels.support_top_case },
    { code: 'support_valise', value: labels.support_valise },
    { code: 'systeme_traqueur', value: labels.systeme_traqueur },
    { code: 'top_case_dossier', value: labels.top_case_dossier },
    { code: 'telephone_bluetooth', value: labels.telephone_bluetooth },
    { code: 'garde_boue_avant', value: labels.garde_boue_avant },
    { code: 'pot_echappement_sport', value: labels.pot_echappement_sport },
    { code: 'durites_aviation', value: labels.durites_aviation },
    { code: 'selection_titane', value: labels.selection_titane },
    { code: 'leche_roue', value: labels.leche_roue },
    { code: 'suspension_renforcee', value: labels.suspension_renforcee },
    { code: 'limiteur_de_vitesse', value: labels.limiteur_de_vitesse },
    { code: 'filtre_a_particules', value: labels.filtre_a_particules },
    { code: 'phares_a_led', value: labels.phares_a_led },
    { code: 'stop_start', value: labels.stop_start },
    { code: 'pack_fumeur', value: labels.pack_fumeur },
    { code: 'volant_cuir', value: labels.volant_cuir },
    { code: 'prise_12v', value: labels.prise_12v },
    { code: 'support_gps', value: labels.support_gps },
    { code: 'verrouillage_a_distance', value: labels.verrouillage_a_distance },
    { code: 'predisposition_attelage', value: labels.predisposition_attelage },
    { code: 'palettes_volant', value: labels.palettes_volant },
    { code: 'preequipement_ipod', value: labels.preequipement_ipod },
    { code: 'commandes_vocales', value: labels.commandes_vocales },
    { code: 'demarrage_sans_cle', value: labels.demarrage_sans_cle },
    { code: 'capot_de_selle', value: labels.capot_de_selle },
    { code: 'ecopes_de_radiateur', value: labels.ecopes_de_radiateur },
    { code: 'protege_te_de_fourche', value: labels.protege_te_de_fourche },
    { code: 'intercom_pilote_passager', value: labels.intercom_pilote_passager },
    { code: 'support_plaque_mineralogique', value: labels.support_plaque_mineralogique },
    { code: 'treuil', value: labels.treuil },
    { code: 'protection_de_reservoir', value: labels.protection_de_reservoir },
    { code: 'cache_courroie', value: labels.cache_courroie },
    { code: 'prise_allume_cigare', value: labels.prise_allume_cigare },
    { code: 'roulettes_protection', value: labels.roulettes_protection },
    { code: 'tampon_top_block', value: labels.tampon_top_block },
    { code: 'ouverture_coffre_a_distance', value: labels.ouverture_coffre_a_distance },
    { code: 'laves_phares_avants', value: labels.laves_phares_avants },
    { code: 'cache_bagages', value: labels.cache_bagages },
    { code: 'sieges_arrieres_rabattable', value: labels.sieges_arrieres_rabattable },
    { code: 'bequille_centrale', value: labels.bequille_centrale },
    { code: 'feu_arriere_a_led', value: labels.feu_arriere_a_led },
    { code: 'pack_memoire_conducteur', value: labels.pack_memoire_conducteur },
    { code: 'protection_radiateur', value: labels.protection_radiateur },
    { code: 'trappe_a_ski', value: labels.trappe_a_ski },
    { code: 'compte_tours', value: labels.compte_tours },
    { code: 'essuie_glace_arriere', value: labels.essuie_glace_arriere },
    { code: 'coffre_electrique', value: labels.coffre_electrique },
    { code: 'jantes_alliage', value: labels.jantes_alliage },
    { code: 'jantes_classiques', value: labels.jantes_classiques },
    { code: 'possede_silencieux', value: labels.possede_silencieux },
    { code: 'silencieux_carbone', value: labels.silencieux_carbone },
    { code: 'silencieux_inox', value: labels.silencieux_inox },
    { code: 'silencieux_titane', value: labels.silencieux_titane },
    { code: 'vehicule_tracker', value: labels.vehicule_tracker },
    { code: 'bulle', value: labels.bulle },
    { code: 'saute_vent', value: labels.saute_vent },
    { code: 'leviers_modifies', value: labels.leviers_modifies },
    { code: 'guidon_modifie', value: labels.guidon_modifie },
    { code: 'pieces_carbone', value: labels.pieces_carbone },
    { code: 'filtre_a_air_modifie', value: labels.filtre_a_air_modifie },
    { code: 'sacoche_reservoir', value: labels.sacoche_reservoir },
    { code: 'commandes_avancees', value: labels.commandes_avancees },
    { code: 'reservoir_etendu', value: labels.reservoir_etendu },
    { code: 'selle_solo', value: labels.selle_solo },
    { code: 'soft_close', value: labels.soft_close },
    { code: 'vitres_insonorisees', value: labels.vitres_insonorisees },
    { code: 'vitres_thermo_isolees', value: labels.vitres_thermo_isolees }
  ]
}
